import { config } from './config';

const onBackToShopClick = () => {
  const backToShopLink = config.links.find(({ key }) => key === 'backToShop')?.link;
  window.location.href = backToShopLink ?? '/';
};

export default onBackToShopClick;
